export var DateMode;
(function (DateMode) {
    DateMode[DateMode["DATE_LIMIT"] = 0] = "DATE_LIMIT";
    DateMode[DateMode["AGE_LIMIT"] = 1] = "AGE_LIMIT";
})(DateMode || (DateMode = {}));
//# sourceMappingURL=dateSelect.types.js.map